import type { ServiceItem } from "./services";

/**
 * Whether an editor-saved value holds something to show; blank and missing show nothing.
 * @param {string | undefined} value The value.
 * @returns {boolean} True when it has text.
 */
const hasText = (value: string | undefined): boolean => (value ?? "").trim() !== "";

/**
 * A stable key for a service: its title and link, which the list never repeats.
 * @param {ServiceItem} service The service.
 * @returns {string} The key.
 */
const serviceKey = (service: ServiceItem): string => `${service.title}|${service.href ?? ""}`;

export { hasText, serviceKey };
